var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HalfButton',{attrs:{"extraStyle":_vm.style},on:{"click":function($event){return _vm.showRandomWord()}}},[_vm._v(" "+_vm._s(_vm.countdown || _vm.txt)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }